/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 * Discriminated by ``protocol`` (:class:`cal.SingleTurnChatModelProtocol`). Each protocol
 * exposes only the fields used for that integration (e.g. AINO omits
 * ``assistant_id``; CUSTOM_API includes ``endpoint_url`` and ``response_paths``).
 * @export
 * @interface SingleTurnChatInferencerPolymorphicShared
 */
export interface SingleTurnChatInferencerPolymorphicShared {
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerPolymorphicShared
   */
  protocol: SingleTurnChatProtocolEnum;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerPolymorphicShared interface.
 */
export function instanceOfSingleTurnChatInferencerPolymorphicShared(
  value: object,
): value is SingleTurnChatInferencerPolymorphicShared {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerPolymorphicSharedFromJSON(
  json: any,
): SingleTurnChatInferencerPolymorphicShared {
  return SingleTurnChatInferencerPolymorphicSharedFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerPolymorphicSharedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerPolymorphicShared {
  if (json == null) {
    return json;
  }
  return {
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
  };
}

export function SingleTurnChatInferencerPolymorphicSharedToJSON(
  value?: SingleTurnChatInferencerPolymorphicShared | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
  };
}
